import { SIGNAL_EVENTS_V2_VALUES_ENDPOINT } from "shared/api/signalEvents/v2/api";
import { useSignalEventOccurrencesAttributes } from "shared/api/signalEvents/v2/hooks";
import { SIGNAL_EVENT_OCCURRENCES_V2_GENERIC_FILTER } from "shared/filterDefinitions";

import { UseSchema } from "./types";
import {
  getAttributeMap,
  getDisplayLabelFunction,
  getFilterFunction,
  getSchemaEntryFunction,
  getSchemaForAccessorFunction,
  getSchemaFromAttributes,
} from "./utils/schema-utils";

// Schema for the Asset-page "All event data" table, built from the V2
// occurrences attributes endpoint rather than the V1 bulk AttributesContext.
// The V2 surface exposes a trimmed, asset-keyed column set, so the schema is
// purely attribute-driven with no V1 overrides/relations, and filter options
// load from the V2 /values route.
const useSignalEventOccurrencesV2Schema = (
  accessorsToHide: string[] = []
): UseSchema => {
  const { data: attributes } = useSignalEventOccurrencesAttributes();

  const attributeMap = getAttributeMap(attributes);
  const getDisplayLabel = getDisplayLabelFunction(attributeMap);
  const getFilter = getFilterFunction(
    SIGNAL_EVENT_OCCURRENCES_V2_GENERIC_FILTER,
    attributeMap,
    SIGNAL_EVENTS_V2_VALUES_ENDPOINT
  );
  const getSchemaEntry = getSchemaEntryFunction(getFilter, attributeMap);

  const schema = getSchemaFromAttributes(
    attributes,
    getSchemaEntry,
    {},
    {},
    accessorsToHide
  );

  return {
    schema,
    getDisplayLabel,
    attributeMap,
    attributes,
    attributeAccessors: schema.map(
      ({ accessor, filter }) => filter?.fieldName || accessor
    ),
    getSchemaEntry,
    getSchemaForAccessor: getSchemaForAccessorFunction(schema),
  };
};

export default useSignalEventOccurrencesV2Schema;
